import { NewRelicInstance } from '@/logger/new_relic/new_relic_instance';

// Extending the Window interface with cursor management
declare global {
  interface Window {
    newrelic: NewRelicInstance | null;

    keydown_on: (callback: (e: KeyboardEvent) => void) => void;
    keydown_off: (callback: (e: KeyboardEvent) => void) => void;

    resize_on: (callback: VoidFunction) => void;
    resize_off: (callback: VoidFunction) => void;

    // Cursor management
    cursor_loading: {
      enabled: boolean;
      enable: () => void;
      disable: () => void;
    };
  }
}

// Keep existing window extensions
window.keydown_on = (callback: (e: KeyboardEvent) => void) => {
  window.addEventListener('keydown', callback);
};

window.keydown_off = (callback: (e: KeyboardEvent) => void) => {
  window.removeEventListener('keydown', callback);
};

window.resize_on = (callback: VoidFunction) => {
  window.addEventListener('resize', callback);
};

window.resize_off = (callback: VoidFunction) => {
  window.removeEventListener('resize', callback);
};

export {}; // Ensure this file is treated as a module
